import { render, staticRenderFns } from "./TagsManagerListSentimentSelector.vue?vue&type=template&id=70ec81c8&scoped=true&"
import script from "./TagsManagerListSentimentSelector.vue?vue&type=script&lang=js&"
export * from "./TagsManagerListSentimentSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerListSentimentSelector.vue?vue&type=style&index=0&id=70ec81c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec81c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
